import { ErrorTypes } from '../../../utils/constants.js';
import { baseStructureSchema } from './base.structure.js';
import { blockSchema } from './block.js';
import { MediaType } from './media.js';

const comprehensionStructureSchema = baseStructureSchema.extend({
  query: blockSchema.refine((query) => {
    const hasPDF = query.media?.find((mediaObj) => mediaObj?.type === MediaType.PDF);
    const hasVideo = query.media?.find((mediaObj) => mediaObj?.type === MediaType.VIDEO);
    if (hasPDF || hasVideo) {
      return true;
    }
    if (!query.text) {
      return false;
    }
    const regex = /<(?!img|audio|video|iframe)[^>]+>/g;
    const cleanedText = query.text.replace(regex, "").trim();
    const hasLatex = query.text.includes("<katex");
    return cleanedText.length > 0 || hasLatex;
  }, {
    message: ErrorTypes.EMPTY_QUERY
  })
});

export { comprehensionStructureSchema };
